import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';

function SvgComponent({
  height,
  width
}) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9103 5.9586l.0112.2812.2771.0494c1.9694.3512 3.4514 2.085 3.4514 4.1487 0 1.1022-.4196 2.143-1.1818 2.9333-.7603.7884-1.7777 1.2414-2.8667 1.2775h0l-.0028.0001-.0045.0001h-.0005c-.0606.0003-.6286.0011-6.7119.0011-2.3636 0-4.148-.0001-5.3449-.0003l-1.3536-.0004-.4448-.0003-.0108-.0001H4.727c-1.176-.0337-2.2759-.5192-3.0987-1.3687C.804 12.4289.35 11.3063.35 10.1167c0-1.8072 1.0681-3.4317 2.6904-4.1504l.185-.082.0213-.2013c.1545-1.465 1.391-2.6076 2.8836-2.6076.508 0 .9996.1325 1.4323.3805l.3068.1758.1726-.3085C9.0643 1.4969 10.9863.35 13.1047.35c3.1227 0 5.6816 2.4935 5.8056 5.6086z",
    fill: "#DAF0ED",
    stroke: "#828A90",
    strokeWidth: "0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "13",
    r: "5.65",
    fill: "#FACBCF",
    stroke: "#828A90",
    strokeWidth: ".7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828A90",
    d: "M12.9498 10.5l.7071.7071-4.9497 4.9498L8 15.4497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828A90",
    d: "M13.6569 15.4497l-.7071.7071L8 11.2071l.7072-.7071z"
  }));
}

SvgComponent.defaultProps = {
  height: 19,
  width: 23
};
SvgComponent.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgComponent;